import {
  candidacyStatusToPipelineStage,
  hiddenPipelineCandidacyStatuses,
  pipelineStageOrder,
} from "@/lib/constants";
import { MinimalCandidacy, PipelineStage } from "@/types";

const bucketCandidacy = (candidacy: MinimalCandidacy): PipelineStage | null => {
  const { toStatus, fromStatus } = candidacy.lastCandidacyStatusChange;
  if (hiddenPipelineCandidacyStatuses.includes(toStatus)) {
    return fromStatus ? candidacyStatusToPipelineStage[fromStatus] : null;
  }
  return candidacyStatusToPipelineStage[toStatus];
};

export const pipeline = {
  bucketedCandidacies: (
    candidacies: MinimalCandidacy[],
  ): { stage: PipelineStage; rows: MinimalCandidacy[] }[] => {
    // Initialize stage groups to empty arrays (no candidacies in that stage yet)
    const groupsByStage: Record<PipelineStage, MinimalCandidacy[]> = {
      [PipelineStage.APPLIED]: [],
      [PipelineStage.IN_COMMUNICATION]: [],
      [PipelineStage.SCREEN_SCHEDULED]: [],
      [PipelineStage.TO_REVIEW]: [],
      [PipelineStage.PREP_TO_SEND]: [],
      [PipelineStage.SUBMITTED]: [],
      [PipelineStage.INTERVIEW]: [],
      [PipelineStage.PLACED]: [],
    };

    // Bucket each candidacy into the appropriate stage group
    for (const candidacy of candidacies) {
      const stage = bucketCandidacy(candidacy);
      if (!stage) continue;
      groupsByStage[stage].push(candidacy);
    }

    return pipelineStageOrder.map((stage) => ({
      stage,
      rows: groupsByStage[stage],
    }));
  },
};
